import React from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';

function TermsOfService() {
    return (
        <div className="terms-of-service-container container">
            <h1>REGULAMIN KORZYSTANIA ZE STRONY INTERNETOWEJ</h1>
            <h2>japamietam.pl</h2>
            <p>(“Regulamin”)</p>

            <h2>1. O czym jest ten dokument?</h2>
            <p>
                To Regulamin korzystania ze strony internetowej japamietam.pl (“Strona Internetowa”),
                prowadzonej przez Radosława Poprawę, przedsiębiorcę prowadzącego działalność
                gospodarczą pod firmą Radosław Poprawa przy ul. Chociszewskiego 6C/4, 64-100 Leszno,
                NIP: 8971850739, REGON: 369259670 („Usługodawca” lub “My”).
            </p>
            <p>Dowiesz się tutaj między innymi:</p>
            <ul>
                <li>na jakich zasadach możesz korzystać ze Strony Internetowej,</li>
                <li>jak działają oferowane przez nas Usługi,</li>
                <li>jakie są Twoje prawa i obowiązki jako użytkownika,</li>
                <li>w jaki sposób reagujemy na treści nielegalne lub nadużycia – zgodnie z Rozporządzeniem (UE) 2022/2065 (Digital Services Act, w skrócie “DSA”).</li>
            </ul>
            <p>
                W skrócie: jeśli zapalasz znicz dla swoich bliskich przez nasz Formularz, korzystasz z usługi
                świadczonej drogą elektroniczną. Ten Regulamin opisuje jej działanie, Twoje
                prawa i nasze obowiązki jako usługodawcy.
            </p>

            <h2>2. Jak rozumiemy niektóre słowa użyte w tym Regulaminie?</h2>
            <ul>
                <li><strong>Formularz</strong> – formularz dostępny na Stronie, umożliwiający wpisanie treści upamiętnienia swoich bliskich, wybór znicza oraz zainicjowanie płatności.</li>
                <li><strong>Nielegalne Treści</strong> – wszystko, co jest niezgodne z prawem Unii Europejskiej lub któregokolwiek państwa członkowskiego, niezależnie od formy (np. wpisy, linki, komentarze).</li>
                <li><strong>Umowa</strong> - umowa zawierana na odległość o świadczenie usługi cyfrowej w rozumieniu przepisów o prawach konsumenta.</li>
                <li><strong>Usługa</strong> – usługa cyfrowa polegająca na umożliwieniu Użytkownikowi stworzenia symbolicznego, cyfrowego znicza dla osoby zmarłej, dostępnego pod indywidualnym adresem URL. Usługa ta jest dostępna na terenie Unii Europejskiej.</li>
                <li><strong>Użytkownik, Ty, Ciebie</strong> – pełnoletnia osoba fizyczna lub osoba fizyczna o ograniczonej zdolności prawnej (za odpowiednią zgodą) korzystająca ze Strony w celu zapalenia symbolicznego znicza.</li>
            </ul>

            <h2>3. Jakie Usługi oferujemy przez Stronę Internetową?</h2>
            <p>Przez Stronę Internetową świadczymy Usługę w postaci:</p>
            <ul>
                <li>możliwości wypełnienia Formularza zawierającego 3 pola tekstowe, w których Użytkownik może wpisać dowolną treść:
                    <ul>
                        <li>ku pamięci kogo jest ten znicz,</li>
                        <li>jaka jest wiadomość pamiątkowa i</li>
                        <li>od kogo jest to upamiętnienie,</li>
                    </ul>
                </li>
                <li>wyboru jednego z dostępnych wzorów zniczy,</li>
                <li>zapisania danych w systemie i nadania im unikalnego identyfikatora,</li>
                <li>dokonania płatności za pomocą zintegrowanej bramki płatności Przelewy24,</li>
                <li>wyświetlenia opłaconego znicza pod indywidualnym adresem w formacie: <code>www.japamietam.pl/read/[ID-znicza]</code>.</li>
            </ul>
            <p>Usługa ma charakter symboliczny i niematerialny – jej celem jest wyłącznie stworzenie wirtualnego miejsca pamięci, a nie sprzedaż towaru.</p>

            <h2>4. Warunki świadczenia Usługi</h2>
            <p><strong>Wymagania techniczne.</strong> Aby korzystać z Usługi, potrzebujesz:</p>
            <ul>
                <li>urządzenia z dostępem do Internetu,</li>
                <li>aktualnej przeglądarki obsługującej JavaScript i cookies,</li>
                <li>aktywnego adresu e-mail,</li>
                <li>dostępu do systemu płatności online obsługiwanego przez wybranego operatora.</li>
            </ul>
            <p><strong>Szczególne zagrożenia związane z korzystaniem z usług elektronicznych.</strong> Korzystanie z usług świadczonych drogą elektroniczną wiąże się z typowymi zagrożeniami, takimi jak:</p>
            <ul>
                <li>możliwość przechwycenia danych przez osoby nieuprawnione,</li>
                <li>ryzyko ataków <em>phishingowych</em> lub <em>malware</em>,</li>
                <li>możliwość utraty danych w wyniku awarii połączenia lub błędu użytkownika.</li>
            </ul>
            <p>Stosujemy odpowiednie środki techniczne i organizacyjne w celu ograniczenia tych ryzyk (m.in. szyfrowanie HTTPS, kontrola dostępu, aktualizacje bezpieczeństwa).</p>
            <p>Strona wykorzystuje wyłącznie pliki cookies o charakterze technicznym, niezbędne do prawidłowego działania serwisu. Nie wprowadzamy do Twojego urządzenia żadnych danych ani oprogramowania innych niż niezbędne do świadczenia Usługi.</p>

            <h2>5. Jak korzystać z naszej Usługi?</h2>
            <p>Aby zapalić znicz, wystarczy:</p>
            <ul>
                <li>wypełnić Formularz, wypełniając pola tekstowe (“Ku pamięci:”, “Wiadomość pamiątkowa”, “Od kogo:”),</li>
                <li>wybrać wzór znicza,</li>
                <li>kliknąć przycisk „Zapal znicz”,</li>
                <li>opłacić Usługę przez dostępną bramkę płatności,</li>
                <li>po pomyślnym dokonaniu płatności otrzymasz link do swojego znicza. Link do znicza oraz powiązane z nim dane (treść wpisu, identyfikator, adres IP i status płatności) są przechowywane przez okres 12 miesięcy od dnia dokonania płatności, po czym zostają trwale usunięte z systemu. Po upływie tego czasu dostęp do linku może wygasnąć, a treść nie będzie już dostępna publicznie.</li>
            </ul>
            <p>Dane zapisane w systemie obejmują treść wpisaną w Formularzu, numer wzoru znicza, przypisany identyfikator, status transakcji, adres IP Użytkownika oraz techniczne dane płatności (status, linki transakcyjne).</p>
            <p>Usługa „Zapal Znicz” jest realizowana automatycznie po zaksięgowaniu płatności dokonanej za pośrednictwem operatora Przelewy24.Zazwyczaj dzieje się to w ciągu kilku minut od momentu dokonania płatności, a w wyjątkowych przypadkach - nie później niż w ciągu 24 godzin.</p>
            <p>Po zaksięgowaniu płatności link do wygenerowanego znicza zostaje automatycznie udostępniony Użytkownikowi pod indywidualnym adresem URL.</p>

            <h2>6. Płatności</h2>
            <p>6.1. Za korzystanie z Usługi pobierana jest opłata określona każdorazowo przy Formularzu w wysokości 4,99 zł (słownie: cztery złote dziewięćdziesiąt dziewięć groszy) brutto.</p>
            <p>
                6.2. Płatność realizowana jest za pośrednictwem operatora Przelewy24 – PayPro S.A., z siedzibą w Poznaniu, przy ulicy Pastelowej 8 (60-198), wpisany do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań Nowe Miasto i Wilda, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem KRS 0000347935, numerem NIP 7792369887, o kapitale zakładowym wynoszącym 4 737 100,00 zł, w całości opłaconym oraz do rejestru krajowych instytucji płatniczych prowadzonego przez Komisję Nadzoru Finansowego pod numerem UKNF IP24/2014. Więcej informacji na temat świadczonej przez operatora usługi płatniczej dowiesz się tutaj.
            </p>
            <p>6.3. Po wybraniu opcji płatności Użytkownik zostaje przekierowany na stronę operatora w celu dokonania transakcji.</p>
            <p>6.4. Po zaksięgowaniu płatności Usługodawca udostępnia Użytkownikowi link do zapalonego znicza pod indywidualnym adresem URL.</p>
            <p>6.5. W przypadku niepowodzenia transakcji link może pozostać tymczasowo aktywny wyłącznie w celach podglądu, bez oznaczenia jako opłacony.</p>
            <p>6.6. Rozliczenia transakcji prowadzone są zgodnie z regulaminem operatora płatności.</p>

            <h2>7. Prawa autorskie</h2>
            <p>
                Grafiki zniczy udostępniane w ramach Usługi są generowane przy użyciu narzędzi sztucznej inteligencji. W związku z tym nie stanowią utworów w rozumieniu ustawy o prawie autorskim i prawach pokrewnych, a więc nie są objęte ochroną prawnoautorską.
            </p>
            <p>Usługodawca zachowuje jednak prawa do sposobu prezentacji, układu strony, baz danych i oznaczeń identyfikujących Stronę Internetową.</p>
            <p>Po opłaceniu Usługi Użytkownik uzyskuje prawo do niekomercyjnego korzystania z wygenerowanego znicza – w szczególności do jego przeglądania, udostępniania linku i okazjonalnego zapisu na własne potrzeby pamięciowe.</p>
            <p>Zabronione jest:</p>
            <ul>
                <li>wykorzystywanie wygenerowanych zniczy lub elementów Strony w celach komercyjnych,</li>
                <li>tworzenie kopii serwisu, jego bazy danych lub elementów interfejsu,</li>
                <li>usuwanie oznaczeń identyfikujących Stronę lub modyfikowanie grafiki w sposób sugerujący inne pochodzenie usługi.</li>
            </ul>

            <h2>8. Obowiązki Użytkownika</h2>
            <p>Korzystając ze Strony Internetowej, zobowiązujesz się do:</p>
            <ul>
                <li>podawania prawdziwych danych w Formularzu,</li>
                <li>korzystania z Usługi w sposób zgodny z prawem i dobrymi obyczajami,</li>
                <li>okazywania szacunku dla pamięci osób zmarłych oraz innych Użytkowników.</li>
            </ul>
            <p>Nie wolno Ci:</p>
            <ul>
                <li>zamieszczać Nielegalnych Treści lub treści obraźliwych,</li>
                <li>podszywać się pod inne osoby ani naruszać dóbr osobistych innych,</li>
                <li>podejmować działań mogących zakłócić działanie Strony lub systemu płatności.</li>
            </ul>
            <p>Za treść wprowadzoną do Formularza odpowiadasz wyłącznie Ty.</p>

            <h2>9. Reagowanie na Nielegalne Treści (DSA)</h2>
            <p>Nie monitorujemy aktywnie treści wprowadzanych przez Użytkowników.</p>
            <p>
                Każdy może zgłosić podejrzenie, że dana treść narusza prawo lub Regulamin, wysyłając wiadomość na adres: <a href="mailto:kontakt.japamietam@gmail.com">kontakt.japamietam@gmail.com</a> z dopiskiem „DSA – zgłoszenie treści”.
            </p>
            <p>Zgłoszenie powinno zawierać:</p>
            <ul>
                <li>link (URL) do treści,</li>
                <li>krótkie uzasadnienie,</li>
                <li>dane kontaktowe (osoba zgłaszająca może pozostać anonimowa).</li>
            </ul>
            <p>
                Po otrzymaniu wiarygodnej informacji niezwłocznie usuniemy lub zablokujemy treść i poinformujemy o podjętej decyzji osoby zainteresowane. Usługodawca prowadzi rejestr decyzji w sprawie zgłoszonych treści, zgodnie z art. 16 DSA.
            </p>

            <h2>10. Odpowiedzialność Usługodawcy</h2>
            <p>Usługodawca nie ponosi odpowiedzialności za:</p>
            <ul>
                <li>treści wprowadzone przez Użytkowników,</li>
                <li>przerwy w działaniu Strony spowodowane modernizacją, awarią lub działaniem siły wyższej (w szczególności: wojny, epidemii, powodzi, awarii elektrycznych, zakłóceń),</li>
                <li>problemy techniczne leżące po stronie operatorów płatności lub dostawców Internetu.</li>
            </ul>
            <p>W przypadku rażącego naruszenia Regulaminu lub prawa możemy:</p>
            <ul>
                <li>usunąć treść,</li>
                <li>zablokować dostęp Użytkownika do Strony,</li>
                <li>rozwiązać umowę o świadczenie usług drogą elektroniczną.</li>
            </ul>

            <h2>11. Przetwarzanie danych osobowych</h2>
            <p>
                W związku z korzystaniem przez Ciebie z naszych Usług, przetwarzamy dane osobowe w celu ich świadczenia i rozliczenia płatności. Szczegółowe informacje na temat przetwarzanych przez nas danych osobowych znajdziesz w <Link to="/polityka-prywatnosci">Polityce Prywatności</Link>.
            </p>

            <h2>12. Reklamacje</h2>
            <ul>
                <li>Reklamacje dotyczące działania Strony Internetowej lub Usługi można składać mailowo na adres <a href="mailto:kontakt.japamietam@gmail.com">kontakt.japamietam@gmail.com</a>, z dopiskiem “Reklamacja”.</li>
                <li>Reklamacja powinna zawierać opis problemu, datę zdarzenia i adres URL znicza (jeśli dotyczy).</li>
                <li>Rozpatrzymy reklamację w terminie 14 dni od jej otrzymania i poinformujemy Cię o tym jak ją rozpatrzyliśmy.</li>
            </ul>

            <h2>13. Zawarcie i rozwiązanie Umowy</h2>
            <ul>
                <li>Umowa zawierana jest z chwilą kliknięcia „Zapal znicz” i kończy się z chwilą wygenerowania i udostępnienia linku do znicza.</li>
                <li>Link do zapalonego znicza jest dostępny przez 12 miesięcy od dnia opłacenia Usługi. Po tym czasie znicz i związane z nim dane zostaną trwale usunięte.</li>
                <li>Możesz zrezygnować z Usługi w dowolnym momencie przed dokonaniem płatności – bez konsekwencji.</li>
                <li>Możemy zakończyć świadczenie Usługi w przypadku naruszenia Regulaminu lub prawa.</li>
            </ul>

            <h2>14. Odstąpienie od Umowy</h2>
            <p>Z uwagi na charakter Usługi (dostarczanie treści cyfrowych niedostarczanych na nośniku materialnym, za które Użytkownik jest zobowiązany do zapłaty ceny) prawo do odstąpienia od umowy <strong>nie przysługuje</strong>, jeżeli:</p>
            <ul>
                <li>Usługodawca rozpoczął świadczenie Usługi za wyraźną i uprzednią zgodą Użytkownika,</li>
                <li>Użytkownik został poinformowany przed rozpoczęciem świadczenia, że po jego spełnieniu utraci prawo odstąpienia od umowy,</li>
                <li>Użytkownik przyjął to do wiadomości,</li>
                <li>a Usługodawca dostarczył mu potwierdzenie zawarcia umowy wraz z informacją o utracie prawa odstąpienia od umowy na trwałym nośniku (np. w wiadomości e-mail po dokonaniu płatności).</li>
            </ul>
            <p>Kliknięcie przycisku „Zapal znicz” oznacza wyraźną zgodę na rozpoczęcie świadczenia Usługi przed upływem 14 dni od jej zawarcia i potwierdzenie przyjęcia do wiadomości, że po jej pełnym wykonaniu prawo odstąpienia od umowy nie będzie przysługiwać.</p>
            <p>Jeżeli płatność nie zostanie zrealizowana, umowa nie zostaje zawarta, a żadne świadczenia nie są wykonywane.</p>

            <h2>15. Postanowienia końcowe</h2>
            <ul>
                <li>Regulamin jest udostępniony nieodpłatnie na Stronie przed zawarciem umowy oraz w sposób umożliwiający jego pobranie, utrwalenie i odtworzenie przez Ciebie.</li>
                <li>Regulamin może ulegać zmianom w przypadku zmiany przepisów prawa lub rozwoju funkcjonalności Strony. Zmiany nie wpływają na Usługi zrealizowane przed ich wejściem w życie.</li>
                <li>O zmianach Regulaminu poinformujemy co najmniej 2 dni przed ich wejściem w życie poprzez publikację na Stronie.</li>
                <li>Możesz skontaktować się z nami pod adresem: <a href="mailto:kontakt.japamietam@gmail.com">kontakt.japamietam@gmail.com</a></li>
                <li>Regulamin obowiązuje od dnia 01.11.2025.</li>
            </ul>

            <div className="back-link-container">
                <Link to="/" className="btn">Powrót do strony głównej</Link>
            </div>
        </div>
    );
}

export default TermsOfService;
